import React, { useMemo } from 'react'
import { Box, FlagIcon, getFlagByCode, Icon, H4 } from '@maui/elements'
import { useActorIndicatorsFetch } from '@nautilusjs/mati-apis'
import { SearchPreviewHeader, SearchPreviewListGrid, ShowMoreDescription } from './common'
import { getCountryCode } from '../../icons/ActorIcon'

export const ActorSearchPreview = ({ data }) => {
  const {
    id,
    name,
    description,
    aliases = [],
    motivations,
  } = data
  const { data: actorIndicators } = useActorIndicatorsFetch(id)

  const icon = useMemo(() => {
    if (!data) return
    const countryCode = getCountryCode(data)
    return getFlagByCode(countryCode)
      ? <FlagIcon style={{ height: '32px', width: '32px' }} code={countryCode}/>
      : <Icon name='user-secret' size='lg' verticalAlign='-12.7px' color='colorActionPrimary'/>
  }, [data])

  return (
    <Box>
      <SearchPreviewHeader
        name={name}
        icon={icon}
        indicators={actorIndicators}

      />
      <Box p='16px' background='colorBackgroundPage' color='colorTextMain'>
        <Box>
          <H4 m={0}>Summary</H4>
        </Box>
        <Box pt='16px'>
          <ShowMoreDescription description={description}/>
        </Box>
        <Box pt='16px'>
          {!!aliases?.length && (
            <SearchPreviewListGrid
              title='Reported As'
              list={aliases}
              cellWidth={['50%', '50%']}/>
          )}
          {!!motivations?.length && (
            <SearchPreviewListGrid
              title='Motivations'
              list={motivations}
              cellWidth={['50%', '50%']}
            />
          )}
        </Box>
      </Box>
    </Box>
  )
}
